// src/pages/Work/MyRole/MyRole.js
import React from 'react';
import './MyRole.css';

function MyRole() {
  return (
    <div className="section-container">
      {/* Main heading and subtitle */}
      <h2 className="main-heading">
        My Role <span className="heading-subtitle">Responsibilities</span>
      </h2>

      {/* Business Partners */}
      <h3 className="section-heading">Business Partners:</h3>
      <ul className="role-list">
        <li>
          <strong>Worked closely with Product Owners</strong> (PO) to align stakeholder needs with application functionality.
        </li>
        <li>
          <strong>Identified UX/UI design challenges</strong> by pinpointing pain points and delivering effective design solutions.
        </li>
        <li>
          Ensured seamless alignment <strong>between user needs and business goals</strong> in all design processes.
        </li>
        <li>
          <strong>Refreshed the look</strong> and improved the usability of various <strong>desktop and mobile applications</strong> for leading clients, identifying issues and iterating designs based on feedback.
        </li>
        <li>
          <strong>Collaborated with developers</strong> in an <strong>Agile</strong> environment to create and implement design solutions efficiently and flexibly for customer projects.
        </li>
      </ul>

      {/* Backstage Partners */}
      <h3 className="section-heading">Backstage Partners:</h3>
      <ul className="role-list">
        <li>
          <strong>Enhanced the usability</strong> of internal <strong>developer tools</strong>, making them more user-friendly and efficient.
        </li>
        <li>
          <strong>Modernized and developed new tools</strong> to support developer teams in their workflows.
        </li>
        <li>
          <strong>Ensured UX/UI consistency and coherence across developer applications, creating intuitive and visually consistent designs.</strong>
        </li>
        <li>
          <strong>Delivered both small and large UX/UI improvements</strong> to optimize the functionality and experience of developer tools.
        </li>
      </ul>

      {/* Team Collaboration */}
      <h3 className="section-heading">Team Collaboration:</h3>
      <ul className="role-list">
        <li>
          <strong>10 developer teams</strong> working in both Agile and Waterfall methodologies (implementation and software engineers)
        </li>
        <li>
          <strong>Product management</strong> teams from <strong>Poland and Germany</strong>
        </li>
        <li>
          <strong>Product owners</strong>
        </li>
        <li>
          <strong>Technical writers</strong>
        </li>
      </ul>
    </div>
  );
}

export default MyRole;